import { useCallback, useRef } from 'react';

const useRuntimeReconciliationBlock = () => {
    const isBlockedRef = useRef(false);

    const setRuntimeBlocksReconciliation = useCallback((blocksReconciliation) => {
        isBlockedRef.current = Boolean(blocksReconciliation);
    }, []);

    const resetRuntimeReconciliationBlock = useCallback(() => {
        isBlockedRef.current = false;
    }, []);

    const isRuntimeReconciliationBlocked = useCallback(() => {
        return isBlockedRef.current;
    }, []);

    return {
        isRuntimeReconciliationBlocked,
        resetRuntimeReconciliationBlock,
        setRuntimeBlocksReconciliation,
    };
};

export default useRuntimeReconciliationBlock;
